module.exports = __webpack_public_path__ + "js/1-e8b3e149cbd1053b8f3e.chunk.worker.js"